import React from 'react'
import { Row, Col } from 'react-bootstrap'

import ExecutiveOfficer from './ExecutiveOfficer'

import COChadGuillerault from './COChadGuillerault'
import COBJeremyRooks from './COBJeremyRooks'
import COB from './COB'
const CrewSection = () => (
    <>
    <COChadGuillerault />
    <ExecutiveOfficer />
    
    <COB />
</>
)

export default CrewSection